module.exports = __webpack_public_path__ + "static/src/content/silks/ten_sovereigns.e32e1b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/silks/ten_sovereigns.png
// module id = jcR3
// module chunks = 0